"use client"

import React from "react"

export default function IdleMount({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  const [ready, setReady] = React.useState(delay === 0)

  React.useEffect(() => {
    let canceled = false
    let id: any
    const fire = () => {
      if (!canceled) setReady(true)
    }
    if (delay > 0) {
      // Prefer requestIdleCallback, fallback to setTimeout
      // @ts-ignore
      const ric: any = typeof window !== 'undefined' && (window as any).requestIdleCallback
      if (ric) {
        // @ts-ignore
        id = ric(() => {
          setTimeout(fire, delay)
        }, { timeout: 2000 })
      } else {
        id = setTimeout(fire, delay)
      }
      return () => {
        canceled = true
        // @ts-ignore
        const cic: any = typeof window !== 'undefined' && (window as any).cancelIdleCallback
        if (cic && id) cic(id)
        else if (id) clearTimeout(id)
      }
    } else {
      // No delay: still prefer idle
      // @ts-ignore
      const ric: any = typeof window !== 'undefined' && (window as any).requestIdleCallback
      if (ric) {
        // @ts-ignore
        id = ric(fire, { timeout: 1500 })
        return () => {
          // @ts-ignore
          const cic: any = typeof window !== 'undefined' && (window as any).cancelIdleCallback
          if (cic && id) cic(id)
        }
      } else {
        fire()
      }
    }
  }, [delay])

  if (!ready) return null
  return <>{children}</>
}
